import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface PamSearchData {
  pamCode: string;
  searchCount: number;
}

export const GetPamSearchCountsByDate = async (fromDate: string,
  toDate: string,
  pamCode: string,
  token: string): Promise<PamSearchData[]> => {
    
  const baseUrl = getApiBaseUrl();
  const apiUrl = `${baseUrl}/api/Admin/GetPamCodeSearchCountsByDateAsync?fromDate=${fromDate}&toDate=${toDate}&pamCode=${pamCode}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch PAM search data: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    // console.error('Error in GetPamSearchCountsByDate:', error);
    throw error;
  }
};
